import { posterInfo2022Api } from '@/api/yearReport';
import { REPORT2024_DETAIL_UPDATE, REPORT2024_FORM_UPDATE, REPORT2024_SOURCES_UPDATE } from '../mutationTypes';

const state = {
  sources: {},
  detail: {
    id: '',
    bindTime: '', // 绑车日期
  },
  form: {
    isAgreement: false,
    submitClick: false,
  },
};
const mutations = {
  [REPORT2024_SOURCES_UPDATE](states, sources) {
    Object.keys(sources).forEach((key) => {
      states.sources[key] = sources[key];
    });
  },
  [REPORT2024_DETAIL_UPDATE](states, detail) {
    console.log(detail);
    states.detail = detail;
  },
  [REPORT2024_FORM_UPDATE](states, value) {
    states.form = { ...JSON.parse(JSON.stringify(states.form)), ...value };
  },
};
const actions = {
  async getData({ commit }, params) {
    console.log('getData');
    console.log(params);
    const resData = await posterInfo2022Api({});
    if (resData.code) {
      commit('REPORT2024_DETAIL_UPDATE', {});
    } else {
      commit('REPORT2024_DETAIL_UPDATE', resData.data);
    }
  },
};
const getters = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
